/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowUpward: {
  name: 'arrow-upward';
  data: string;
} = {
  name: 'arrow-upward',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>`
};
